import { faCopy } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useState } from "react"

export function CopyButton(props: Readonly<Props>) {
  const { id, label, copiedLabel } = props

  const [isPayloadCopied, setIsPayloadCopied] = useState(false)

  const copyToClipboard = () => {
    const selection = window.getSelection?.()
    const element = document.getElementById(id)
    const range = document.createRange()
    if (element !== null) range.selectNode(element)
    if (selection !== null) {
      selection.removeAllRanges()
      selection.addRange(range)
      document.execCommand("copy")
      selection.removeAllRanges()
    }
    setIsPayloadCopied(true)
    setTimeout(() => setIsPayloadCopied(false), 1000)
  }

  return (
    <button
      type="button"
      className="grid grid-cols-[max-content,minmax(0,1fr)] items-center justify-start gap-3 text-left"
      onClick={() => copyToClipboard()}
    >
      <FontAwesomeIcon icon={faCopy} />
      {isPayloadCopied ? copiedLabel : label}
    </button>
  )
}

interface Props {
  id: string
  label: string
  copiedLabel: string
}
